import "hammerjs";
import dispatchCustomEvent from "../Helper/custom-event";
import { StoreFilter } from "../Controllers/StoreFilters";
import { StoreSearch } from "../Controllers/StoreSearch";
import { StoreController } from "../Controllers/StoreController";
import {
  // getCssTranslate3D,
  // getCssScale,
  getParentByClass,
  getParentById,
  hasClass,
} from "../Helper/helper";

/**
 * CLASS
 * Floorplan View
 */
export default class FloorplanView {
  constructor(containerID) {
    /**
     * Constants
     */
    // ID and Class prefixes
    this.singleStoreIDPrefix = "APL_store_";
    this.inactiveStoreElementsContainerID = "APL_inaktiv";
    this.singleStorePatternSuffix = "-img";
    this.highlightStoreClass = "highlight-active-store";

    // Ajax handler
    this.FloorplanAjaxActionFull = "ajax_handle_full_floorplan";
    this.FloorplanAjaxActionMin = "ajax_handle_min_floorplan";
    this.StoresAjaxGetSingleStoreInfos = "ajax_get_single_store_infos";
    this.StoresAjaxGetFloorplanSvgMap = "ajax_handle_get_floorplan_svg_map";

    /**
     * Attributes
     */
    this.container = document.getElementById(containerID);
    this.view = this.container.classList.contains("mb-floorplan-full")
      ? "full"
      : "min";
    this.containerID = containerID;
    this.activeStoreNumber = this.container.dataset.activeStoreNumber ?? "";
    this.showModal = this.container.hasAttribute("data-show-modal")
      ? this.container.dataset.showModal.toLowerCase() === "true" // conver string to boolean
      : true;
    this.interactive = this.container.dataset.interactive ?? "true";
    this.popup = this.container.dataset.popup ?? "true";
    this.controls = this.container.dataset.controls ?? "true";
  }

  /** ============================ METHODS ========================================== */

  initFloorplan() {
    const that = this;
    const ajaxAction =
      that.view == "full"
        ? this.FloorplanAjaxActionFull
        : this.FloorplanAjaxActionMin;

    window.floorplanScrolling = false;

    jQuery.ajax({
      url: mb_plugin_globalvars.ajaxurl,
      type: "POST",
      data: {
        action: ajaxAction,
        activeStoreNumber: that.activeStoreNumber,
        controls: that.controls,
      },
      success: function (response) {
        //do something on success
        that.container.classList.remove("mb-loading");
        that.container.innerHTML = response.data;

        that.infoContainer = that.container.querySelector(
          "#mb-floorplan-store-information-container"
        );

        const svgFloorplanContainer = that.container.querySelector(
          ".mb-floorplan-container-fluid"
        );
        const svgFloorplanWrapper = that.container.querySelector(
          ".mb-floorplan-container-svg-wrapper"
        );
        const svgFloorplan = that.container.querySelector(
          ".mb-floorplan-container-svg-wrapper svg"
        );

        if (!svgFloorplan || !svgFloorplanContainer) return;

        // Update drawing controller
        window.DrawingController.svg = svgFloorplan;
        window.DrawingController.svgContainer = svgFloorplanContainer;
        window.DrawingController.svgWrapper = svgFloorplanWrapper;

        // initial position
        window.DrawingController.initialPosition();

        if (that.activeStoreNumber) {
          that.goToStore(
            that.activeStoreNumber.replace(".", "_"),
            false,
            true,
            that.showModal
          );
        }

        // Init filters
        StoreFilter.initFilters();
        StoreFilter.initResponsiveStoreFilterSelect();

        // Init search
        StoreSearch.initSearch();
        // Init aditional functionality
        that.#initFoorplanEventHandlers();
      },
      error: function (xhr) {
        //do something on error
        console.log("Error", xhr.responseText);
      },
    });
  }

  // showStoreDetails(storeId) {
  //   jQuery.ajax({
  //     url: mb_plugin_globalvars.ajaxurl,
  //     type: "POST",
  //     data: {
  //       action: this.StoresAjaxGetSingleStoreInfos,
  //       storeId: storeId,
  //     },
  //     success: function (response) {
  //       //do something on success
  //       that.container.classList.remove("mb-loading");
  //       that.container.innerHTML = response.data;
  //     },
  //     error: function () {
  //       //do something on error
  //       // console.log("Error");
  //     },
  //   });
  // }

  goToStore(id, animate = true, force = false, showModal = true) {
    const storePath = document.getElementById(this.singleStoreIDPrefix + id);

    if (storePath) {
      this.activeStoreNumber = id;
      this.#initStoreClickHandler(storePath, animate, force, showModal);
    }

    // // setup interaction settings after init position
    // window.DrawingController.interactive =
    //   window.DrawingController.svg.dataset.interactive;
  }

  closePopup() {
    if (this.interactive == "false") return;

    // this.removeStorehighlight();
    this.infoContainer.classList.remove("active");
  }

  removeStorehighlight() {
    if (this.interactive == "false") return;

    const activeStores = this.container.querySelectorAll(
      "." + this.highlightStoreClass
    );

    for (let i = 0; i < activeStores.length; i++) {
      activeStores[i].classList.remove(this.highlightStoreClass);
    }
  }

  /** ============================ SETTER ========================================== */

  /** ============================ GETTER ========================================== */
  getPrefixes(name) {
    return this[name];
  }

  /** ============================ FUNCTIONS ========================================== */
  /**
   * #initFoorplanEventHandlers()
   */
  #initFoorplanEventHandlers() {
    if (
      !window.DrawingController.svg ||
      !window.DrawingController.svgContainer
      // || window.DrawingController.interactive === "false"
    )
      return;

    const that = this;

    /**
     * Event listener
     */
    // add mousewheel event listener
    window.DrawingController.svgContainer.addEventListener(
      "wheel",
      EventHandler.wheel,
      { passive: false }
    );

    // add drag event listener
    window.DrawingController.svgContainer.addEventListener(
      "mousedown",
      initDragEvent,
      { passive: false }
    );

    // add touchstart listener
    window.addEventListener("touchstart", initDragEvent, { passive: false });

    // add hammer.js pinch (two finger zoom) listener
    let hammertime = new Hammer(window.DrawingController.svgContainer);
    hammertime.get("pinch").set({ enable: true });
    hammertime.on("pinch", function (event) {
      EventHandler.pinch(event);
    });

    function initDragEvent(e) {
      e.cancelBubble = true;

      let target = e.target;

      if (!target.getAttribute("data-action")) {
        target = target.parentNode;
      }

      // handle elements with separate actions
      if (target.getAttribute("data-action")) {
        let action = target.getAttribute("data-action");
        action = action.split("-");
        const task = action[0];
        const data = action[1];
        window.DataActionController[task](data);
        return;
      }

      // handle touch event
      // do nothing if touch outside floorplan container
      if (
        e.type == "touchstart" &&
        !hasClass(target, "mb-floorplan-container-fluid") &&
        getParentByClass(target, "mb-floorplan-container-fluid") === null
      ) {
        // touch outside floorplan container
        // continue page scrolling
        return;
      }

      // handle dragging
      e.preventDefault(); // prevent pagescrolling
      EventHandler.dragstart(e);
    }

    // add click event listener
    document.addEventListener(
      "click",
      function (event) {
        that.#initStoreClickHandler(event.target);
        that.#initFloorSelectionClickHandler(event.target);
        that.#initStoreSelectionClickHandler(event.target);
        that.#initClosePopupStoreInformationHandler(event.target);
        EventHandler.click(event);
      },
      { passive: false }
    );

    document.addEventListener(
      "touchend",
      function (event) {
        const target = event.target;
        that.#initMobileStoreLinkClickhandler(event);
        that.#initStoreClickHandler(target);
        that.#initFloorSelectionClickHandler(target);
        that.#initClosePopupStoreInformationHandler(target);
        EventHandler.click(event);
      },
      { passive: false }
    );
  }

  /**
   * #initStoreClickHanlder
   * @param {DOM} target
   */
  #initStoreClickHandler(
    target,
    animate = true,
    force = false,
    showModal = true
  ) {
    if (this.interactive == "false" && !force) return;
    if (window.EventHandler.mousemoved) return; // no click if dragging

    if (
      !getParentById(target, this.inactiveStoreElementsContainerID) &&
      target.id != "undefined" &&
      target.id.indexOf(this.singleStoreIDPrefix) !== -1
    ) {
      const storeID = target.id.substring(this.singleStoreIDPrefix.length);
      const translate = this.#getStoreCenterAfterZoom(target);

      // highlight active store
      this.removeStorehighlight();
      target.classList.add(this.highlightStoreClass);

      const placeholderBG = this.container.querySelector(
        "#store_logo_bg_" + storeID
      );

      if (placeholderBG) {
        placeholderBG.classList.add(this.highlightStoreClass);
      }

      // center store incl. animation
      window.DrawingController.moveAndZoom(
        translate.x,
        translate.y,
        translate.z,
        animate
      );

      if (showModal) {
        StoreController.getStoreInformationPopupContent(
          storeID,
          this.infoContainer
        );
      }
    }
  }

  /**
   * #initFloorSelectionClickHanlder
   * @param {DOM} target
   */
  #initFloorSelectionClickHandler(target, open_select = true) {
    const that = this;

    if (target.classList.contains("mb-floorplan-floorselection-floor")) {
      let listItem = target;

      if (listItem.closest("ul").classList.contains("open") || !open_select) {
        that.#filterFloors(target);
        listItem.closest("ul").prepend(listItem);
      }
      // else {
      //   window.DrawingController.initialPosition(true);
      // }

      if (open_select) {
        listItem.closest("ul").classList.toggle("open");
      }
    }
  }

  /**
   * #initStoreSelectionClickHandler
   * includes handling for stores on multiple floors
   * @param {DOM} target
   */
  #initStoreSelectionClickHandler(target) {
    if (target.classList.contains("store-title")) {
      const that = this;
      const singleStore = getParentByClass(target, "mb-floorplan-single-store");
      const storenumber = singleStore.dataset.storenumber;
      const floors = singleStore.dataset.floor.split(";");
      const showModal = singleStore.hasAttribute("data-show-modal")
        ? singleStore.dataset.showModal.toLowerCase() === "true" // conver string to boolean
        : true;
      const floorplans = [];
      let shopOnActiveFloor = false;

      for (let i = 0; i < floors.length; i++) {
        let floorplan = document.querySelector(
          '[data-floor-slug="' + floors[i] + '"]'
        );

        if (floorplan) {
          floorplans.push(floorplan);

          // check if store on active floor
          if (!shopOnActiveFloor) {
            shopOnActiveFloor = floorplan.classList.contains("floor-active");
          }
        }
      }

      // if no floor found
      if (floorplans.length < 1) {
        console.error("Whoops! Floor is wrong!");
        return;
      }

      // Close mobile store list select
      StoreFilter.showHideResponsiveStoreSelect(
        that.container.querySelector(".mb-floorplan-store-list-mobile-label"),
        "false"
      );

      if (shopOnActiveFloor) {
        // If current floor correct
        that.goToStore(storenumber, true, false, showModal);
      } else {
        // switch to first available floor
        // call and listen custom event
        // that.#initFloorSelectionClickHandler(floorplans[0], storenumber);
        that.#initFloorSelectionClickHandler(floorplans[0], false);
        window.addEventListener("floorSwitched", goStoreTemp);

        function goStoreTemp() {
          that.goToStore(storenumber, true, false, showModal);
          this.removeEventListener("floorSwitched", goStoreTemp);
        }
      }
    }
  }

  #initClosePopupStoreInformationHandler(target) {
    if (
      !target.id.indexOf("mb-floorplan-store-information-container") !== -1 && // popup clicked
      !getParentById(target, "mb-floorplan-store-information-container") && // clicked inside popup
      target.id.indexOf(this.singleStoreIDPrefix) === -1 && // other store clicked
      (getParentByClass(target, "mb-floorplan-container-fluid") ||
        target.classList.contains("mb-floorplan-container-fluid")) // clicked outside map
    ) {
      this.closePopup();
    }
  }

  #getStoreCenterAfterZoom(target) {
    const svgContainer = window.DrawingController.svgContainer;
    const svgWrapper = window.DrawingController.svgWrapper;

    const storeID = target.id.substring(this.singleStoreIDPrefix.length);
    const storeLogoPattern = document.getElementById(
      this.singleStoreIDPrefix + storeID + this.singleStorePatternSuffix
    );

    const svgContainerBounding = svgContainer.getBoundingClientRect();
    const storeRectBounding = target.getBoundingClientRect();

    const currentZoom = svgWrapper.getAttribute("data-zoomlevel")
      ? parseFloat(svgWrapper.getAttribute("data-zoomlevel"))
      : 1;

    // get target zoom
    let targetZoom = storeLogoPattern
      ? storeLogoPattern.dataset.storeZoom
      : window.DrawingController.initialZoom;

    /**
     * BEFORE ZOOM
     */
    const absoluteCenterBeforeZoomX =
      (svgContainer.offsetWidth - svgWrapper.offsetWidth) / 2;
    const absoluteCenterBeforeZoomY =
      (svgContainer.offsetHeight - svgWrapper.offsetHeight) / 2;

    const storeToCenterX =
      svgContainer.offsetWidth / 2 +
      svgWrapper.offsetLeft -
      (storeRectBounding.left -
        (svgContainerBounding.left - storeRectBounding.width / 2));
    const storeToCenterY =
      svgContainer.offsetHeight / 2 +
      svgWrapper.offsetTop -
      (storeRectBounding.top -
        (svgContainerBounding.top - storeRectBounding.height / 2));

    const diffToAbsoluteCenterBeforeZoomX =
      absoluteCenterBeforeZoomX - storeToCenterX;
    const diffToAbsoluteCenterBeforeZoomY =
      absoluteCenterBeforeZoomY - storeToCenterY;

    /**
     * AFTER ZOOM
     */
    const absoluteCenterAfterZoomX =
      (svgContainer.offsetWidth - svgContainer.offsetWidth * targetZoom) / 2;
    const absoluteCenterAfterZoomY =
      (svgContainer.offsetHeight - svgContainer.offsetHeight * targetZoom) / 2;

    const diffToAbsoluteCenterAfterZoomX =
      (diffToAbsoluteCenterBeforeZoomX / currentZoom) * targetZoom;
    const diffToAbsoluteCenterAfterZoomY =
      (diffToAbsoluteCenterBeforeZoomY / currentZoom) * targetZoom;

    return {
      x: absoluteCenterAfterZoomX - diffToAbsoluteCenterAfterZoomX,
      y: absoluteCenterAfterZoomY - diffToAbsoluteCenterAfterZoomY,
      z: targetZoom,
    };
  }

  #initMobileStoreLinkClickhandler(event) {
    if (
      event.target.classList.contains(
        "mb-floorplan-single-store-information-link-a"
      )
    ) {
      event.preventDefault;
      event.target.click();
      return;
    }
  }

  #filterFloors(target) {
    const that = this;

    const svgFloorplanContainer = this.container.querySelector(
      ".mb-floorplan-container-fluid"
    );

    svgFloorplanContainer.classList.add("mb-loading");

    jQuery.ajax({
      url: mb_plugin_globalvars.ajaxurl,
      type: "POST",
      data: {
        action: this.StoresAjaxGetFloorplanSvgMap,
        floorSlug: target.dataset.floorSlug,
        interactive: that.interactive,
        controls: that.controls,
      },
      success: function (response) {
        svgFloorplanContainer.innerHTML = response.data;
        svgFloorplanContainer.classList.remove("mb-loading");

        that.infoContainer = that.container.querySelector(
          "#mb-floorplan-store-information-container"
        );

        const svgFloorplan = svgFloorplanContainer.querySelector("svg");
        const svgWrapper = svgFloorplanContainer.querySelector(
          ".mb-floorplan-container-svg-wrapper"
        );

        if (!svgFloorplan || !svgFloorplanContainer) return;

        // Update drawing controller
        window.DrawingController.svgWrapper = svgWrapper;
        window.DrawingController.svg = svgFloorplan;
        // window.DrawingController.svgContainer = svgFloorplanContainer;

        // initial position
        window.DrawingController.initialPosition();

        if (that.interactive == "false" && that.activeStoreNumber) {
          // go to active store if interaction is deactivated
          that.goToStore(that.activeStoreNumber, false, true, that.showModal);
        }

        // fire custom event
        dispatchCustomEvent("floorSwitched");
      },
      error: function (xhr) {
        //do something on error
        console.log("Error", xhr.responseText);
      },
    });
  }
}
